import { __extends } from "tslib";
import { deserializeAws_json1_1StartStreamEncryptionCommand, serializeAws_json1_1StartStreamEncryptionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartStreamEncryptionCommand = /** @class */ (function (_super) {
    __extends(StartStreamEncryptionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartStreamEncryptionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartStreamEncryptionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartStreamEncryptionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1StartStreamEncryptionCommand(input, context);
    };
    StartStreamEncryptionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1StartStreamEncryptionCommand(output, context);
    };
    return StartStreamEncryptionCommand;
}($Command));
export { StartStreamEncryptionCommand };
//# sourceMappingURL=StartStreamEncryptionCommand.js.map